export const IMG_OBJECT_FIT = 'cover'

export const IMG_MIN_HEIGHT = '100%'
